angular.module('navigationHeaderModule', ['core']);
